import { visibleNavItems } from "@impero-com/ui";

import type { NavFeatureFlag, NavItem } from "./navTree";

export type NavFlags = Readonly<Record<NavFeatureFlag, boolean>>;

export interface ResolvedNavItem {
    readonly id: string;
    readonly label: string;
    readonly icon?: string;
    readonly lockedIcon?: string;
    readonly href?: string;
    readonly visible: boolean;
    readonly locked: boolean;
}

export function resolveNavItems(
    items: readonly NavItem[],
    flags: NavFlags
): readonly ResolvedNavItem[] {
    return visibleNavItems(items.map((item) => resolveNavItem(item, flags)));
}

function resolveNavItem(item: NavItem, flags: NavFlags): ResolvedNavItem {
    const enabled = item.featureFlag === undefined || flags[item.featureFlag];

    return {
        id: item.id,
        label: item.label,
        icon: item.icon,
        lockedIcon: item.lockedIcon,
        href: item.href,
        visible: enabled || item.lockedWhenFlagOff === true,
        locked: !enabled,
    };
}
